import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header header-elements-inline" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, "Alle Logs als Übersicht"),
  /*#__PURE__*/_createElementVNode("div", { class: "header-elements" })
], -1)
const _hoisted_5 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_6 = { class: "media cursor-pointer align-items-center" }
const _hoisted_7 = { class: "mr-3 d-flex flex-column align-items-center" }
const _hoisted_8 = { class: "media-body" }
const _hoisted_9 = { class: "mr-3" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterBar = _resolveComponent("FilterBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createVNode(_component_FilterBar, {
      filter: _ctx.filter,
      search: _ctx.search,
      onFilter: _ctx.onFilter
    }, null, 8, ["filter", "search", "onFilter"]),
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("ul", _hoisted_5, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logs, (log, logIndex) => {
          return (_openBlock(), _createElementBlock("li", {
            key: logIndex,
            class: ""
          }, [
            _createElementVNode("a", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("a", {
                  href: "#",
                  class: _normalizeClass(["btn bg-transparent rounded-pill border-2 btn-icon", 'text-'+log.class+' border-'+log.class])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(log.icon)
                  }, null, 2)
                ], 2)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, [
                  _createTextVNode(_toDisplayString(log.anlage_bemerkung) + " | " + _toDisplayString(log.anlage_typ) + " | ", 1),
                  _createElementVNode("small", null, _toDisplayString(log.system), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(_ctx.formatDateTime(log.createdAt)) + " | " + _toDisplayString(log.event) + " ", 1),
                  (log.component)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, " | " + _toDisplayString(decodeURIComponent(log.component)), 1))
                    : _createCommentVNode("", true),
                  (log.reason != '' )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, ": " + _toDisplayString(log.reason), 1))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}